<template>
  <v-autocomplete
    v-model="myCountry"
    :items="countryItems"
    :label="label || $t('views.core.countrySelector.country')"
    :disabled="disabled"
    :placeholder="placeholder"
    :hide-details="hideDetails"
    :clearable="clearable"
  ></v-autocomplete>
</template>

<script>
import { orderBy } from 'lodash'
import { allCountries } from '@/lib/countries/countries.js'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    countries: {
      type: Array,
      default: allCountries,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    translateName: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    myCountry: null,
  }),
  computed: {
    countryItems() {
      return orderBy(
        this.countries.map((country) => {
          let text
          if (this.translateName) {
            text = this.$te(`common.countries.${country.countryCode}`)
              ? this.$t(`common.countries.${country.countryCode}`)
              : country.countryCode
          } else {
            text = country.countryName
          }
          return {
            key: country.countryCode,
            value: country.countryCode,
            text,
          }
        }),
        ['text']
      )
    },
  },
  watch: {
    myCountry: {
      handler() {
        if (this.myCountry === undefined) {
          // para cuando limpio el exposure country en fondos
          this.$emit('input', null)
          return
        }

        if (!this.myCountry) return
        if (this.myCountry === this.value) return
        this.$emit('input', this.myCountry)
      },
      deep: true,
    },
    value: {
      handler() {
        this.myCountry = this.value
      },
      immediate: true,
    },
  },
}
</script>

<style></style>
